import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorHandler extends Component {
  static propTypes = {
    children: PropTypes.node,
    hasError: PropTypes.bool,
    errorClass: PropTypes.string,
    shouldScrollToError: PropTypes.bool,
    scrollTargetClass: PropTypes.string,
  };

  static defaultProps = {
    errorClass: 'field-with-error',
    shouldScrollToError: false,
    hasError: false,
    scrollTargetClass: 'error-target',
  };

  state = {
    hasUnCaughtError: false,
  };

  scrollToError(field) {
    field.scrollIntoView({ behavior: 'smooth' });
  }

  componentDidUpdate() {
    const { shouldScrollToError, errorClass, scrollTargetClass, hasError } = this.props;

    let field = document.querySelector(`.${errorClass}`);
    const target = document.querySelector(`.${scrollTargetClass}`);

    if (field && field.contains(target)) {
      field = target;
    }

    if (hasError && field && shouldScrollToError) {
      this.scrollToError(field);
    }
  }

  componentDidCatch(error) {
    // something went terribly wrong
    this.setState({ hasUnCaughtError: error });
  }

  render() {
    const hasError = this.props.hasError || this.state.hasUnCaughtError;
    const { errorClass, children } = this.props;

    return (
      <span className={hasError ? errorClass : null}>
        {children}
        {this.state.hasUnCaughtError ? 'uncaught.error' : ''}
      </span>
    );
  }
}

export default ErrorHandler;
